/*eslint-disable*/
import { types } from "../types/types";

const initialState = {
  assistance: [],
};

export const assistanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.assistanceLoad:
      return {
        ...state,
        ...action.payload,
      };

    case types.reset:
      return initialState;

    default:
      return state;
  }
};
